<template>
  <div class="upload-page">

    <!-- change the headline slightly by context. this is mostly for verifying the context -->
    <h1 v-if="context == 'new-design'">Upload your Business Card</h1>
    <h1 v-else-if="context == 'add-design'">Upload Design</h1>
    <h1 v-else-if="context == 're-upload'">Re-upload your Business Card</h1>
    <h1 v-else>Upload Business Card</h1>

    <div class="editor-wrapper">
      <UploaderBox @upload="onUpload" @error="onError" :extra="{is_template: true}"/>
      <SideMenu class="side-menu"></SideMenu>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {expanded, compressed} from '@/lib/selectedProduct';

  import UploaderBox from '../../upload/UploaderBox.vue';
  import SideMenu from '../../upload/SideMenu.vue';
  import FixedMenu from '../../upload/FixedMenu.vue';

  import {designUploadVisited, designUploadSuccess, designUploadError} from '@/lib/track/events';

  export default {
    components: {UploaderBox, SideMenu, FixedMenu},
    async mounted() {
      // TODO determine context
      designUploadVisited(this.context)
    },
    computed: {
      ...mapGetters(['productTemplateDesignId', 'hasMultipleProductTemplates']),
      context() {
        return this.productTemplateDesignId ? 're-upload' : this.hasMultipleProductTemplates ? 'add-design' : 'new-design';
      }
    },
    methods: {
      ...mapActions(['setDesign']),
      async onUpload(event) {
        designUploadSuccess();
        event.preventDefault();
        let {design} = event;
        this.setDesign(design);
        return this.$router.push({name: 'Editor', params: {id: design.id}});
      },
      async onError(event) {
        designUploadError(event);
      }
    }
  }
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 0;
}
.editor-wrapper{
  display: flex;
  min-width:504px;
  max-width:840px;
  margin: 0 auto;
}
.side-menu {
  margin-left: 2em;
}

// at 1120px, the action cards of SideMenu just touch the dashboard outer box
@media screen and (max-width: 1120px) {
  .editor-wrapper {
    flex-flow: column nowrap;
  }
  .side-menu {
    margin-left: 0;
    display: flex;
    max-width: 504px;
    justify-content: space-between;
  }
}

h1 {
  // Ensure "Upload your Business Card" does not wrap
  @media screen and (max-width: 870px){
    font-size: 2.2em;
  }
  @media screen and (max-width: 680px){
    font-size: 2em;
  }
  @media screen and (max-width: 620px){
    font-size: 1.8em;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/dashboard/design/NewDesign.vue